var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLightning = function SvgLightning(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2173 1.28224C14.5337 1.37801 14.75 1.66956 14.75 2.00006V9.25006H19C19.2766 9.25006 19.5307 9.4023 19.6613 9.64616C19.7918 9.89003 19.7775 10.1859 19.624 10.4161L11.624 22.4161C11.4407 22.6911 11.099 22.8137 10.7827 22.7179C10.4663 22.6221 10.25 22.3306 10.25 22.0001V14.7501H6C5.7234 14.7501 5.46926 14.5978 5.33875 14.354C5.20823 14.1101 5.22254 13.8142 5.37596 13.584L13.376 1.58403C13.5593 1.30904 13.901 1.18647 14.2173 1.28224ZM7.40139 13.2501H11C11.4142 13.2501 11.75 13.5858 11.75 14.0001V19.523L17.5986 10.7501H14C13.5858 10.7501 13.25 10.4143 13.25 10.0001V4.47714L7.40139 13.2501Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLightning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Lightning.29685d5578a36df0bfafa59e97d97be9.svg";